import {
  WSAlert,
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { TaxFilingFAQ } from "../../components/TaxFilingFAQ/TaxFilingFAQ";
import React from "react";
import { BusinessInformation } from "./BusinessInformation";
import { SupportInformation } from "./SupportInformation";
import { CalculationInformation } from "./CalculationInformation";
import { StateFilingInformation } from "./StateFilingInformation";
import { FormType } from "./FormType";
import {
  TAX_FILING_1099_FILING_PREVIEW_PATH,
  useGoToTaxFilingPath
} from "../../paths";
import { useCurrentTaxFilingYear } from "../../utils/useCurrentTaxFilingYear";

export type RouteTaxFilingSettingsProps = {};

export const RouteTaxFilingSettings: React.FC<
  RouteTaxFilingSettingsProps
> = ({}) => {
  const currentYear = useCurrentTaxFilingYear();
  const goToPreview = useGoToTaxFilingPath(TAX_FILING_1099_FILING_PREVIEW_PATH);

  return (
    <WSPage>
      <WSPageToolbar
        breadcrumbs={[
          {
            label: `1099 filing ${currentYear}`,
            onClick: () => {
              goToPreview();
            }
          },
          {
            label: `${currentYear} Tax filing settings`
          }
        ]}
        title={`${currentYear} tax filing settings`}
      />
      <WSAlert
        theme="info"
        icon="info-circle"
        title="About filing settings"
        mb="2XL"
      >
        These settings apply to all new tax forms. Form type can be changed each
        year and will be locked-in for that year once set.
      </WSAlert>
      <WSGrid>
        <WSGrid.Item span={{ m: "8" }}>
          <WSList gap="2XL">
            <BusinessInformation />
            <SupportInformation />
            <FormType />
            <CalculationInformation />
            <StateFilingInformation />
          </WSList>
        </WSGrid.Item>
        <WSGrid.Item span={{ m: "4" }}>
          <TaxFilingFAQ mt="S" />
        </WSGrid.Item>
      </WSGrid>
    </WSPage>
  );
};
